// extracted by mini-css-extract-plugin
export default {"shimmer":"EmbeddedDefaultPayoutMethod_shimmer__Hnr9G"};